import { z } from 'src/lib'
import { schemaEntityWithIdAndDescription } from '../baseSchemas'

export const SistemaPrincipalFields = {
    SrcIcono: 'rutaIconoSistemaPrincipal'
} as const

export const schemaSistemaPrincipal = z
    .object({
        [SistemaPrincipalFields.SrcIcono]: z.string()
    })
    .merge(schemaEntityWithIdAndDescription)

export type SistemaPrincipal = z.infer<typeof schemaSistemaPrincipal>

export const EtapaEstadosFields = {
    HexColor: 'hexColor'
} as const

const schemaEtapaEstadosFields = z
    .object({
        [EtapaEstadosFields.HexColor]: z.string()
    })
    .merge(schemaEntityWithIdAndDescription)

export type EtapaEstado = z.infer<typeof schemaEtapaEstadosFields>

